module.exports = __webpack_public_path__ + "static/media/icomoon.feab2195.eot";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/icomoon.eot?v1g914
// module id = 108
// module chunks = 0